export const TOURNAMENT_STATUS = {
  CANCELED: 0,
  WEB_ACTIVE: 1,
  FINISHED: 2,
  PENDING: 3,
  IN_PROCESS: 4,
  STOPPED: 5,
};
